<template>
    <div class="mx-2  pt-2 ">
        <loading v-model:active="pageLoader" :can-cancel="false" loader="dots" color="#02C782"
            background-color="#818585" width="130" height="130" :is-full-page="true" />
        <div class="flex justify-between mt-10 md:mt-0 items-baseline	">
            <h1 style="font-weight: 550;" class="text-2xl  mb-5 md:mt-10 mt-3">Staff</h1>
            <!-- v-if="hasCnaCreateUser" -->

        </div>
        <div class="qr-code-input flex-wrap  justify-between md:mb-0 mb-5">
            <div class="qr-code-input flex-wrap flex items-center justify-between md:mb-0 mb-5">
                <div class="flex flex-wrap md:w-80  items-baseline mb-5" v-if="hascanduImportstaff">
                    <label class="block w-[150px]  text-sm text-bg-save font-medium  text-[17px] dark:text-white"
                        for="file_input">Upload
                        Excel</label>
                    <input @change="handleFileUpload"
                        class="block w-full text-sm  text-gray-900 border border-gray-300 rounded-lg cursor-pointer bg-gray-50 dark:text-gray-400 focus:outline-none dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400"
                        aria-describedby="file_input_help" id="file_input" type="file">
                    <p class="mt-1 text-sm text-gray-500 dark:text-gray-300" id="file_input_help"></p>
                    <a style="cursor: pointer;" class="text-[#1C64F2] pt-1  underline text-xs  "
                        @click="downloadFile">Download Template</a>
                </div>

                <router-link v-if="hasCnaCreatestaff" to="/CreateStaff" style="background: #2E2C72;"
                    class="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-4 py-2 md:px-5 md:py-2.5 dark:bg-regal-blue dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800">Create
                    Staff
                </router-link>

                <!-- <div class="pdf export" v-if="hascanduExportstaff">
                    <button style="background-color:#02C782 ;" :disabled="isLoadingExcel" @click="handleexportexcel"
                        class="text-white bg-bg-save hover:bg-hover-save focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800 inline-flex items-center relative">
                        {{ isLoadingExcel ? 'Exporting ' : 'Export Excel' }}
                        <svg v-if="isLoadingExcel" aria-hidden="true" role="status"
                            class="inline ms-2 w-4 h-4 text-white animate-spin" viewBox="0 0 100 101" fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                                fill="#E5E7EB" />
                            <path
                                d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                                fill="currentColor" />
                        </svg>

                    </button>
                </div> -->
            </div>
        </div>
        <div class="flex flex-column sm:flex-row flex-wrap space-y-4 sm:space-y-0 items-center justify-between  pb-4">
            <div>

                <span class="text-base">
                    show:
                    <select @change="fetchStaff('isshowuser')" v-model="number" class="rounded-lg" id="quantity"
                        name="quantity" style="border: 1px solid white; border-top: #F9F9F9;">
                        <option value="10">10</option>
                        <option value="25">25</option>
                        <option value="50">50</option>
                    </select>
                    &nbsp; entries
                </span>
            </div>
            <form>
                <div class="flex items-baseline">
                    <button  v-if="hascanduExportstaff" style="background-color:#02C782 ;height: 40px; " :disabled="isLoadingExcel" @click="handleexportexcel"
                        class="text-white bg-bg-save hover:bg-hover-save focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800 inline-flex items-center relative">
                        {{ isLoadingExcel ? 'Exporting ' : 'Export Staff' }}
                        <svg v-if="isLoadingExcel" aria-hidden="true" role="status"
                            class="inline ms-2 w-4 h-4 text-white animate-spin" viewBox="0 0 100 101" fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                                fill="#E5E7EB" />
                            <path
                                d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                                fill="currentColor" />
                        </svg>

                    </button>
                    <label for="default-search"
                        class="mb-2 text-sm font-medium text-gray-900 sr-only dark:text-white">Search</label>
                    <div class="relative">
                        <input type="search" v-model="searchQuery" style="padding-left: 20px; width: 350px; "
                            id="default-search"
                            class="block w-full p-4 pl-10 ps-20 text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                            placeholder="Search" required>
                        <button type="button" @click.prevent="handlesearch"
                            class="text-white bg-button-blue absolute end-2.5 bottom-2  hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-[10px] py-[12px] dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">
                            <svg style="" class="w-10 h-4  text-white dark:text-gray-400" aria-hidden="true"
                                xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
                                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                                    stroke-width="2" d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z" />
                            </svg></button>
                    </div>
                </div>
            </form>
        </div>

        <div class="relative overflow-x-auto overflow-hidden  shadow-md ">
            <table class="w-full text-sm  border text-left rtl:text-right text-gray-500 dark:text-gray-400">
                <thead class="text-xs text-gray-700  bg-stone-300 dark:bg-gray-700 dark:text-gray-400">
                    <tr>
                        <th scope="col" class="px-6 py-3">
                            Id
                        </th>
                        <th scope="col" class="px-6 py-3">
                            <div class="flex items-center">
                                Name
                            </div>
                        </th>
                        <th scope="col" class="px-6 py-3">
                            <div class="flex items-center">
                                Father Name
                            </div>
                        </th>
                        <th scope="col" class="px-6 py-3">
                            <div class="flex items-center">
                                Code
                            </div>
                        </th>
                        <th scope="col" class="px-6 py-3">
                            <div class="flex items-center">
                                Cnic
                            </div>
                        </th>
                        <th scope="col" class="px-6 py-3">
                            <div class="flex items-center">
                                Employee Code
                            </div>
                        </th>
                        <th scope="col" class="px-6 py-3">
                            <div class="flex items-center">
                                Phone
                            </div>
                        </th>
                        <th scope="col" class="px-6 py-3">
                            <div class="flex items-center">
                                Age
                            </div>
                        </th>
                        <th scope="col" class="px-6 py-3">
                            <div class="flex items-center">
                                Hospital Name
                            </div>
                        </th>
                        <th scope="col" class="px-6 py-3">
                            <div class="flex items-center">
                                Staff Type
                            </div>
                        </th>
                        <th scope="col" class="px-6 py-3">
                            <div class="flex items-center">
                                Email
                            </div>
                        </th>
                        <th scope="col" class="px-6 py-3">
                            <div class="flex items-center">
                                Addrass
                            </div>
                        </th>
                        <th scope="col" class="px-6 py-3">
                            <div class="flex items-center">
                                Created At
                            </div>
                        </th>
                        <th scope="col" class="px-6 py-3">
                            <div class="flex items-center">
                                Updated At
                            </div>
                        </th>
                        <th scope="col" class="px-6 py-3">
                            <div class="flex items-center">
                                Created By
                            </div>
                        </th>
                        <th scope="col" class="px-6 py-3">
                            <div class="flex items-center">
                                Updated By
                            </div>
                        </th>
                        <!-- v-if="hascanupdateuser" -->
                        <th scope="col" class="px-6 py-3" v-if="hascanupdaterStaff">
                            <span class="flex items-center ">Edit</span>
                        </th>
                        <!-- v-if="hascandeleteuser" -->
                        <th scope="col" class="px-6 py-3" v-if="hascandeletestaff">
                            <span class="flex items-center">Delete</span>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(staf, index) in staff" :key="staf.id"
                        class="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
                        <td class="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white">{{
            calculateSerialNumber(index) }}
                        </td>
                        <td class="px-6 py-4">{{ staf?.name }}</td>
                        <td class="px-6 py-4">{{ staf?.father_name }}</td>
                        <td class="px-6 py-4">{{ staf?.code }}</td>
                        <td class=" py-4">{{ staf?.cnic }}</td>
                        <td class="px-6 py-4">{{ staf?.employee_code }}</td>
                        <td class="px-6 py-4">{{ staf?.phone }}</td>
                        <td class="px-6 py-4">{{ staf?.age }}</td>
                        <td class="px-6 py-4">{{ staf?.hospital?.name }}</td>
                        <td class="px-6 py-4">{{ staf?.staff_type?.type }}</td>
                        <td class="px-6 py-4">{{ staf?.email }}</td>
                        <td class="px-6 py-4">{{ staf?.addrass }}</td>
                        <td class="px-6 py-4">{{ staf?.created_at }}</td>
                        <td class="px-6 py-4">{{ staf?.updated_at }}</td>
                        <td class="px-6 py-4">{{ staf?.created_by?.display_name }}</td>
                        <td class="px-6 py-4">{{ staf?.updated_by?.display_name }}</td>

                        <!-- <td class="px-6 py-4" >  <span>{{ role.permissions.map(rol => rol?.name).join(', ') }}</span></td>  -->

                        <td class="px-6 py-4 ">
                            <router-link v-if="hascanupdaterStaff" :to="'/updatestaffs-' + staf.id"
                                class="font-medium text-blue-600 dark:text-blue-500 hover:underline">Edit</router-link>
                        </td>
                        <td class="px-6 py-4 " v-if="hascandeletestaff" style="cursor: pointer;">
                            <a @click="deltestaff(staf.id)" style="color: red;"
                                class="font-medium text-blue-600 dark:text-blue-500 hover:underline">Delete</a>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="flex justify-end mt-2">
            <vue-awesome-paginate :total-items="totalpage" class="overflow-hidden pl-5" :items-per-page="1"
                :max-pages-shown="5" v-model="currentPage" :on-click="onClickHandler" :hide-prev-next-when-ends="true"
                next-button-content=">" />
        </div>
    </div>
</template>
<script setup>
import { ref, watch, computed, onMounted, onUnmounted } from 'vue';
import axiosInstance from "@/plugins/axios"
import Swal from 'sweetalert2';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';
import { useScanCodeStore } from '@/store/QRScanCode';
const qrscancode = useScanCodeStore();
const isLoadingExcel = ref(false);
const pageLoader = ref(false);
const staff = ref([])
// const chunk = ref(1)
const number = ref(10)
const currentPage = ref(1);
const totalpage = ref()
const searchQuery = ref('');
function downloadFile() {
    const downloadLink = "http://13.50.122.252:8080/import-templates/staff_import_template.xlsx";
    window.open(downloadLink, "_blank");
}

const handleexportexcel = async () => {
    isLoadingExcel.value = true;
    try {
        await qrscancode.getExcelStaff(); // Assuming this is an asynchronous function
    } catch (error) {
        console.error('Error exporting Excel:', error);
        // Handle errors as needed
    } finally {
        isLoadingExcel.value = false;
    }
}
const handleFileUpload = (event) => {
    const file = event.target.files[0];
    uploadFile(file);
};

const uploadFile = async (file) => {
    pageLoader.value = true;
    try {
        const formData = new FormData();
        formData.append('file', file);

        const response = await axiosInstance.post('/staffs/import', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
        pageLoader.value = false;

        Swal.fire({
            icon: 'success',
            title: 'staff imported successfully',
            text: ''
        });
    } catch (error) {
        pageLoader.value = false;
        Swal.fire({
            icon: 'warning',
            title: 'staff import failed',
            text: error.response.data.message
        });
    }
};
const isapplys = ref(false)

const calculateSerialNumber = (index) => {
    // Calculate serial number based on page, limit, and index
    if (isapplys.value === true) {
        return index + 1
    }
    if (currentPage.value === 1) {
        return index + 1;
    } else {
        return (currentPage.value - 1) * number.value + index + 1;
    }
};

const handlesearch = async (e) => {
    await fetchStaff('isshowuser');
}
const fetchStaff = async (isshowuser) => {
    try {
        if (isshowuser === 'isshowuser') {
            currentPage.value = 1
            const response = await axiosInstance.get(`/staffs/${number.value}/${searchQuery.value}?page=${currentPage.value}`);
            staff.value = response.data.data.data
            totalpage.value = response.data.data.last_page;
            // console.log(response.data.data.data);
        } else {
            const response = await axiosInstance.get(`/staffs/${number.value}/?page=${currentPage.value}`);
            staff.value = response.data.data.data
            totalpage.value = response.data.data.last_page;
        }

    } catch (error) {
        console.error('Error fetching district info:', error);
        // Handle error or show error message
    }
}
const onClickHandler = () => {
    fetchStaff()
    // pagniationpage.value =  true
}
const deltestaff = async (id) => {
    const confirmed = await Swal.fire({
        title: 'Are you sure?',
        text: 'You want to delete this staff?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
    });
    const response = await axiosInstance.delete(`/staffs/${id}`);

    if (confirmed.isConfirmed) {
        try {

            Swal.fire(
                'Deleted!',
                'Your staff has been deleted.',
                'success'
            );
            fetchStaff()
        } catch (error) {
            console.error('Failed to delete Shift:', error);
            Swal.fire(
                'Error!',
                'Failed to delete Shift.',
                'error'
            );
        }
    }
};
import { useAuthService } from '@/store/Auth'; //  auth.js file
const authStore = useAuthService();
const permissions = ref([])
onMounted(() => {
    const authData = authStore.authData;
    permissions.value = authStore.authData.permissions

});
const hasCnaCreatestaff = computed(() => permissions.value.some(permission => permission.name === 'can create staff'));
const hascanupdaterStaff = computed(() => permissions.value.some(permission => permission.name === 'can update staff'));
const hascandeletestaff = computed(() => permissions.value.some(permission => permission.name === 'can delete staff'));
const hascanduImportstaff = computed(() => permissions.value.some(permission => permission.name === 'can import staff'));
const hascanduExportstaff = computed(() => permissions.value.some(permission => permission.name === 'can export staff'));


onMounted(async () => {
    await authStore.handlepermission()
})

onUnmounted(async () => {
    await authStore.handlepermission()
})
onMounted(() => {
    fetchStaff()
})
</script>